import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QuizBlockDTO, QuizTypes } from '@app/infrastructure/models/quiz-block';

@Component({
  selector: 'app-shared-quiz-block-viewer',
  templateUrl: './shared-quiz-block-viewer.component.html',
  styleUrls: ['./shared-quiz-block-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedQuizBlockViewer {
  @Input() block: QuizBlockDTO;
  public quizTypes = QuizTypes;
}
